import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper.jsx';
import { createRoot } from "react-dom/client";
import { MsalWrapper } from "./auth/MsalWrapper.jsx";

const root = createRoot(document.getElementById('root'));

root.render(
	<BrowserRouter>
		<MsalWrapper>
			<AppWrapper />
		</MsalWrapper>
	</BrowserRouter>
);
